// extracted by mini-css-extract-plugin
module.exports = {"container":"_f10557a"};